export default __webpack_public_path__ + "static/media/gha.835bf351.svg";